import { PATHS } from '@/constants';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Button } from '@tis/shared-tis-ui';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../Dialog.module.scss';

interface DetailsUpdatedSuccessDialogProps {
  onClose?: () => void;
}

const DetailsUpdatedSuccessDialog: React.FC<
  DetailsUpdatedSuccessDialogProps
> = ({ onClose }) => {
  const navigate = useNavigate(); // Get the navigate function

  const handleClose = () => {
    navigate(PATHS.APPLICANT.MY_ACCOUNT);
    onClose && onClose();
  };
  return (
    <>
      <DialogContent className={styles.dialogContent}>
        <div className={styles.dialogHeader}>
          <CheckCircleIcon className={styles.checkIcon} />
          <Typography
            component="h5"
            variant="h5"
            sx={{ fontSize: '20px', fontWeight: 'bold' }}
          >
            Account Details have been successfully updated
          </Typography>
        </div>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button variant="outlined" onClick={handleClose}>
          Return to my account
        </Button>
      </DialogActions>
    </>
  );
};

export default DetailsUpdatedSuccessDialog;
